<template>
  <div class="w1200" style="margin-top: 15px">
    <template
      v-if="
        userModule.roles.filter((el) => el.id == 'ThematicResourceManager')
          .length > 0
      "
    >
      <div class="bg" style="padding: 40px">
        <el-steps :active="active" align-center>
          <el-step title="创建专题" description="专题名称、专题页面"></el-step>
          <el-step title="专题资源" description="新增专题、调用资源"></el-step>
          <el-step title="完成创建"></el-step>
        </el-steps>
      </div>

      <div class="bg">
        <div v-if="active == 1">
          <attribute v-model="active" @getId="getId"></attribute>
        </div>
        <div v-if="active == 2">
          <div class="hd ys2">
            <h3>被选用的资源</h3>
            <div class="fr">
              <upload1
                style="float: left; margin-right: 10px"
                :value="a"
                @input="uploadSectionFile"
                :size="1024 * 1024 * 3"
                :url="url"
                :auth="auth"
                ><el-button type="primary" size="mini">上传新资源</el-button>
              </upload1>
              <el-button
                type="primary"
                size="mini"
                @click="
                  upLoadBaseShow = true;
                  upLoadNewsShow = false;
                "
                >引用资源库</el-button
              >
            </div>
          </div>
          <div class="upload">
            <div class="hd">
              <h4>
                已上传资料<em>{{ data.length }}份</em>
              </h4>
              <span></span>
            </div>
            <div class="bd">
              <ul>
                <li v-for="(d, i) in data" :key="'upload' + i">
                  <span class="sn">{{ i + 1 }}</span
                  ><em>*</em><span class="title">标题</span
                  ><el-input
                    placeholder="请输入内容"
                    v-model="d.resourceName"
                    style="width: 450px"
                    size="small"
                  >
                    <svg
                      class="icon"
                      aria-hidden="true"
                      slot="prefix"
                      width="30"
                    >
                      <use :xlink:href="'#icontbx' + d.fileType"></use>
                    </svg>
                  </el-input>
                  <span class="suffix">{{ d.type }}</span>
                  <el-button type="text" @click="del(d, i)">删除</el-button>
                </li>
              </ul>
            </div>
          </div>
          <!-- <ul>
            <li v-for="(d, i) in data" :key="i">
              <div class="icon">
                <el-popover placement="right" width="800" trigger="hover">
                  <img
                    v-if="d.fileType == 4"
                    :src="uploadUrl + d.fileUrl"
                    style="max-width: 100%"
                    alt=""
                  />
                  <iframe
                    v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                    :src="previewUrl + uploadUrl + d.fileUrl"
                    frameborder="0"
                    style="width: 100%"
                  ></iframe>
                  <svg class="icon" aria-hidden="true" slot="reference">
                    <use :xlink:href="'#icontbd' + d.fileType"></use>
                  </svg>
                </el-popover>
                <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                  >- {{ d.filePage }}页 -</em
                >
              </div>
              <div class="title">
                <h5>{{ d.resourceName }}</h5>
                <span class="catalog">
                  <i>{{ d.versionName }}/</i>
                  <i>{{ d.volumeName }}/</i>
                  <i>{{ d.firstChapterName }}/</i>
                  <i>{{ d.secondChapterName }}/</i>
                  <i>{{ d.thirdChapterName }}/</i>
                  <i>{{ d.fourthChapterName }}/</i>
                </span>
                <span class="time">时间：{{ d.createTime }}</span>
                <span class="download">下载量：{{ d.downloadNumber }}</span>
                <span class="collection">收藏量：{{ d.favoriteNumber }}</span>
                <span class="size">大小：{{ d.fileSize }}</span>
                <span class="school">学校：{{ d.schoolName }}</span>
                <span class="author">作者：{{ d.createUserName }}</span>
              </div>
              <div class="operate">
                <el-button type="primary" size="mini" @click="downLoad(d)"
                  >下载</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click="cancelShare(d.resourceId)"
                  >取消共享</el-button
                >
                <el-button
                  v-if="d.isFavorite == 'Y'"
                  type="text"
                  size="mini"
                  style="padding-top: 0"
                  @click="favorite(d)"
                  >收藏</el-button
                >
              </div>
            </li>
          </ul> -->
          <el-button @click="$router.push({ name: 'special' })"
            >取 消</el-button
          >
          <el-button type="primary" @click="save()">完成创建</el-button>
        </div>
      </div>
    </template>
    <el-dialog title="引用资源库" :visible.sync="upLoadBaseShow" width="1230px">
      <quote
        :sectionData="sectionData"
        :activeName="activeName"
        :breadcrumb="breadcrumb"
        :breadcrumbData="breadcrumbData"
        :init1="init"
        @replace="analysisUrl"
        @add="add"
        v-model="data"
        ref="ref"
      ></quote>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="upLoadBaseShow = false">取 消</el-button>
        <el-button type="primary" @click="upLoadBaseShow = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import upload from "../../mixins/upload";
import attribute from "./attribute";
import upload3 from "./upload3";
import quote from "./quote";
import axios from "axios";
import upload1 from "../../common/upload1";
export default {
  data() {
    return {
      active: 1,
      id: "",
      data: [],
      upLoadNewsShow: false,
      upLoadBaseShow: false,
      breadcrumb: [],
      breadcrumbData: {
        section: "",
      },
      activeName: "",
      sectionData: [],
      init: 0,
      previewUrl: "",
      uploadUrl: "",
      list: { typeName: "", typeImage: "", new1: true, id: "" },
      url: "",
      auth: {},
    };
  },
  computed: {
    ...mapState(["userModule"]),
  },
  mixins: [upload],
  components: { attribute, quote, upload1 },
  methods: {
    async uploadSectionFile(params) {
      params = params.map((el) => {
        el.resourceName = el.fileName;
        el.thematicTypeId = this.id;
        el.resourceSource = 1;
        return el;
      });
      this.data.push(...params);
      debugger;
      // this.data.push({
      //   thematicTypeId: this.id,
      //   resourceSource: 1,
      //   resourceName: file.name,
      //   fileType: file.fileType,
      //   type: file.type,
      //   fileUrl: file.url,
      //   fileSize: file.size,
      // });
    },
    add(v) {
      this.data.push(v);
    },
    del(v, i) {
      let a = v.fileUrl.split("/")[1];
      axios
        .post(
          window.sessionStorage.getItem("uploadUrl") + "/" + a + "/deletefile",
          {
            Path: v.fileUrl,
          },
          {
            headers: {
              "Content-Type": "application/json",
              clientId: window.sessionStorage.getItem("clientId"),
              token: window.sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.data.suc) {
            this.$ajax
              .post("/server/thematic/resource/delete", {
                resourceId: v.thematicResourceId,
              })
              .then((res) => {
                this.data.splice(i, 1);
              });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    analysisUrl() {
      this.sectionData = JSON.parse(
        window.sessionStorage.getItem("sectionData")
      );
      this.breadcrumbData = JSON.parse(
        window.sessionStorage.getItem("currentDirectory")
      );
      this.activeName = this.breadcrumbData.sectionId;
      this.breadcrumb = JSON.parse(window.sessionStorage.getItem("breadcrumb"));
      this.init++;
    },
    getId(v) {
      this.id = v;
      // this.id = v;
      // this.$ajax
      //   .post("/server/thematic/resource/listByDate", {
      //     fileType: "",
      //     userName: "",
      //     thematicTypeId: v.id,
      //     page: 1,
      //     size: 10,
      //   })
      //   .then((res) => {
      //     this.data = res.list;
      //   });
    },
    save() {
      if (this.data.length == 0) {
        this.$router.push({ name: "special" });
        return;
      }
      this.data.forEach((el) => {
        el.thematicTypeId = this.id;
      });
      this.$ajax
        .post("/server/thematic/resource/save", this.data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$router.push({ name: "special" });
          this.$message.success("保存成功");
        });
    },
  },
  mounted() {
    this.analysisUrl();
    this.url = window.sessionStorage.getItem("uploadUrl");
    this.auth = {
      clientId: window.sessionStorage.getItem("clientId"),
      token: window.sessionStorage.getItem("token"),
    };
    this.previewUrl = window.sessionStorage.getItem("previewUrl");
    this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
  },
};
</script>

<style>
.el-steps {
  width: 1160px;
  margin: 0 auto;
}
.el-step__description.is-finish,
.el-step__description.is-process {
  color: #999;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:focus,
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/page/special/add.vue